import BaseSelectionFeature from "./base-selection-feature";
import {ActionTypeEnum} from "../../base/training-literals";
import {SelectionObjectTypeEnum} from "../action-literals";

class Highlight extends BaseSelectionFeature {

    constructor(props = {}) {
        super(props);
        this.actionType = props.actionType || ActionTypeEnum.HIGHLIGHT;
    }

    startSelection() {
        if (!this.selectionEnable) {
            updateYellowHighlightFlag(true);
        }

        changeSelectionAction(SelectionActionEnum.Highlight);
        if (this.selectionObjectType === SelectionObjectTypeEnum.Models) {
            SelectionData.changeResetOnOutsideClickState(true);
            onChangeApplyToSelection(false);
        } else if (this.selectionObjectType === SelectionObjectTypeEnum.Volumes) {
            SelectionData.changeResetOnOutsideClickState(true);
            onChangeApplyToSelection(true);
        } else if (this.selectionObjectType === SelectionObjectTypeEnum.Branches) {
            SelectionData.changeResetOnOutsideClickState(false);
            MeshHierarchyViewFeatureManager.resetTreeViewSelection();
            this.show2dItemsForBranchSelection();
        } else if (this.selectionObjectType === SelectionObjectTypeEnum.Groups) {
            SelectionData.changeResetOnOutsideClickState(false);
            MeshHierarchyViewFeatureManager.resetTreeViewSelection();
            this.show2dItemsForGroupSelection();
        }

    }

    stopSelection() {
        VRMessageController.addMessage({
            text: "Selection Stopped",
            priority: VrMessagePriorityEnum.LOWPRIORITYINFO
        });
        if (!this.selectionEnable) {
            updateYellowHighlightFlag(false);
        }
        this.set2dElementsVisibility(true);
        onChangeApplyToSelection(true);
        changeSelectionAction(SelectionActionEnum.NONE);
        ModelTreeControllerFor2D.deselectAllNodes();
        this.change2dVisibility(true);
    }

    selectItems(items, isHighlighted) {
        if (this.selectionObjectType === SelectionObjectTypeEnum.Models) {
            for (const item of items) {
                const clickedPoint = new THREE.Vector3();
                performHighlightOperationOnModel(item.id, SelectionData.reverseHighlight ? 1 : 0, clickedPoint, isHighlighted);
            }
        } else if (this.selectionObjectType === SelectionObjectTypeEnum.Volumes) {
            for (const item of items) {
                const clickedPoint = new THREE.Vector3();
                performHighlightOperationOnVolume(item.id, SelectionData.reverseHighlight ? 1 : 0, clickedPoint, isHighlighted);
            }
        } else if (this.selectionObjectType === SelectionObjectTypeEnum.Branches) {
            for (const item of items) {
                ModelTreeControllerFor2D.onChangeCheckStatus(item.id, isHighlighted);
            }
        } else if (this.selectionObjectType === SelectionObjectTypeEnum.Groups) {
            items = items.map(item => item.id);

            // Clear currentItems from baseselectionfeature for unselected groups in model tree
            if (!isHighlighted) {
                items.forEach(itemID => {
                    let currentGroupItems = ActionController.getActiveAction().getCurrentItems();
                    currentGroupItems = currentGroupItems.filter(item => item.id !== itemID);
                    ActionController.getActiveAction().setCurrentItems(currentGroupItems);
                })
            }

            GroupController.onChangeHighlight(isHighlighted, items, false);
        }

    }

    sendDataOnSelection(data) {
        let msg = text_selectionObjects;
        this.sendDataToWeb(msg.command, data);
    }
}

export default Highlight;